import { RemovalType } from "./_model.releaseOrder";

/**
 * ExitNoteState enum: GENERATED once the note is handed to the customer (its
 * removals can no longer go on another note), CANCELLED when the note was
 * cancelled - its removals are then released for a new note.
 */
export class ExitNoteStateConstant {
  static GENERATED_ID = "GENERATED";
  static CANCELLED_ID = "CANCELLED";

  static OPTIONS = {
    [this.GENERATED_ID]: {
      label: "Généré",
      color: "green",
    },
    [this.CANCELLED_ID]: {
      label: "Annulé",
      color: "red",
    },
  };
}

/**
 * ExitNoteRemovalType enum: the menu the note belongs to (MIXED when one note
 * holds both container gate-outs and goods removals).
 */
export class ExitNoteRemovalTypeConstant {
  static CONTAINER_ID = "CONTAINER";
  static GOODS_ID = "GOODS";
  static MIXED_ID = "MIXED";

  static OPTIONS = {
    [this.CONTAINER_ID]: {
      label: "Conteneurs",
      color: "blue",
    },
    [this.GOODS_ID]: {
      label: "Marchandises",
      color: "purple",
    },
    [this.MIXED_ID]: {
      label: "Mixte",
      color: "gold",
    },
  };
}

/**
 * Everything that differs between the two entry points of the feature. The
 * removalType is what the API expects on pending_removals and what the list is
 * filtered on, so both pages stay identical apart from this configuration.
 */export const RELEASE_ORDER_CONFIG: Record<
  RemovalType,
  {
    title: string;
    /** Ce que l'on enlève, pour les libellés du formulaire. */
    removalLabel: string;
    pendingRemovalsHint: string;
  }
> = {
  CONTAINER: {
    title: "Bons de sortie (Parc à conteneurs)",
    removalLabel: "enlèvement de conteneur",
    pendingRemovalsHint:
      "Sélectionnez un client et une date pour afficher les enlèvements de conteneurs en attente.",
  },
  GOODS: {
    title: "Bons de sortie (Magasin)",
    removalLabel: "enlèvement de marchandises",
    pendingRemovalsHint:
      "Sélectionnez un client et une date pour afficher les enlèvements de marchandises en attente.",
  },
};

/**
 * Ton de la confirmation d'annulation : un rouge de mise en garde (et non
 * d'erreur) pour rester lisible sans être agressif.
 */
export const CANCEL_MESSAGE_COLOR = "#cf1322";

/**
 * Longueur maximale du motif, alignée sur la contrainte du backend
 * (ExitNote::$cancelReason : Assert\Length(max: 255)).
 */
export const CANCEL_REASON_MAX_LENGTH = 255;
